// Minimal pre-auth top bar (back arrow closes the Mini App).
// Ported from the design bundle (screens-auth.jsx · AuthTopBar).
import { Icon, LogoMark } from '../design'

export function AuthTopBar({ onBack }: { onBack: () => void }) {
  return (
    <div
      style={{
        flexShrink: 0,
        height: 52,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        padding: '0 8px',
        borderBottom: '1px solid var(--border)',
        background: 'var(--surface)',
      }}
    >
      <button
        className="ibtn"
        onClick={onBack}
        aria-label="Back"
        style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--text-1)' }}
      >
        <Icon.ArrowLeft size={20} sw={2} />
      </button>
      <div className="row middle gap-2" style={{ marginLeft: 2 }}>
        <LogoMark size={20} />
        <span className="t-body-s" style={{ fontWeight: 700, letterSpacing: '-0.01em' }}>Pilotools</span>
      </div>
    </div>
  )
}
